(function($){
    $(document).ready(function() {
        parallaxBg();
        counter();
        smoothScroll();
        nav();
        });
    function parallaxBg() {
      $(window).load(function() {
        $('#o-nas').parallax("50%", 0.4);
        $('#w-liczbach').parallax("50%", 0.55);
      });
    }
    function counter() {
      $('.counter').counterUp({
        delay: 10,
        time: 1000
      });
    }
    function nav(){
      $('#nav li a').click(function() {
            $('.menu-toggle:visible').click();
        });
      $('.menu-toggle').click(function() {
            $('#header nav').slideToggle();
        });
      $('body').scrollspy({
            target: '#nav',
            offset: 69
        });
    }
    function smoothScroll() {
        $('a[href*="#"]:not([href="#"]):not(.no-scroll)').click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top - 31
                    }, 1000);
                    return false;
                }
            }
        });
    }

})(jQuery); 